import { styled } from "@stitches/react";
import { useAtom } from "jotai";
import React, { useEffect } from "react";
import { ROOM_SERVICE_MAP_KEYS } from "../consts";
import { hasGestureAtom } from "../jotai/atoms";
import { useUserInfos } from "../roomservice/maps";
import { useOnlinesSetup } from "../roomservice/presences";

export function MutedAudioWarning() {
  const [hasGesture, setHasGesture] = useAtom(hasGestureAtom);

  useEffect(() => {
    function enableAudio() {
      setHasGesture(true);
    }
    if (!hasGesture) {
      window.addEventListener("click", enableAudio);
      window.addEventListener("mousedown", enableAudio);
    }
    return () => {
      window.removeEventListener("click", enableAudio);
      window.removeEventListener("mousedown", enableAudio);
    };
  }, [hasGesture, setHasGesture]);

  const [onlines] = useOnlinesSetup();
  const userInfos = useUserInfos();
  const streamingUsersCount = onlines.filter((id) => {
    let key = ROOM_SERVICE_MAP_KEYS.USER + id;
    return !!userInfos[key]?.audio;
  }).length;

  if (hasGesture || streamingUsersCount === 0) return <></>;
  return <GestureWarning>(Click Anywhere to Hear Audio 👂)</GestureWarning>;
}

const GestureWarning = styled("div", {});
